import React from "react";

const Contact: React.FC = () => {
  return (
    <div className="">
      <h1 className="text-3xl font-bold">Contact Page</h1>
      <p>[WIP]</p>
    </div>
  );
};

export default Contact;
